// extracted by mini-css-extract-plugin
module.exports = {"root":"intro_root__oZUVU","image":"intro_image__eXTYg","titles":"intro_titles__yYadi","title":"intro_title__CyAZe","subtitle":"intro_subtitle__v_cWV"};